import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { getAfterAuthRoute } from '@/app/utils/auth/getAfterAuthRoute';
import { LaunchScreen } from '@/view/components/modules/launch-screen';

export const Route = createFileRoute('/')({
  validateSearch: z.object({
    redirect: z.string().optional().catch(''),
  }),
  component: () => <LaunchScreen isLoading />,
  beforeLoad: ({ context, search }) => {
    if (context.auth.signedIn) {
      throw redirect({ to: search.redirect || getAfterAuthRoute() });
    }

    throw redirect({ to: '/auth' });
  },
});
